export default __webpack_public_path__ + "static/media/E-Bikebörse Logo 1.d9e16f21.png";